import Offline from "../models/Offline"
import Detenteur from "../models/Detenteur"
import Installation from "../models/Installation"
import Fibsdd from "../models/Fibsdd"
import Fuite from "../models/Fuite"
import Piece from "../models/Piece"
import PhotoFiche from "../models/PhotoFiche"
import Bouteille from "../models/Bouteille"
import Outil from "../models/Outil"
import User from "../models/User"
import ContratAssemblage from "../models/ContratAssemblage"
import OperationBouteille from "../models/OperationBouteille"
import Scan from "../models/Scan"
import Api from './Api'
import localforage from 'localforage'
import Operateur from "../models/Operateur";
import Initialisation from "./Initialisation";
import InformationInstallation from "../models/InformationInstallation";

class Synchro {

    static async countOperation(type) {

        let count = 0;
        if(type === "detenteur") {
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Detenteur']);
            count = count.length;
        }else if(type === "installation"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Installation']);
            count = count.length
        }else if(type === "bouteille"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Bouteille']);
            count = count.length
        }else if(type === "outil"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Outil']);
            count = count.length
        }else if(type === "assemblage"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'ContratAssemblage']);
            count = count.length
        }else if(type === "fibsdd"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Fibsdd']);
            count = count.length
        }else if(type === "opBouteille"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'OperationBouteille']);
            count = count.length
        }else if(type === "scan"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'ScanBouteille']);
            count = count.length
        }else if(type === "fuite"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Fuite']);
            count = count.length
        }else if(type === "piece"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Piece']);
            count = count.length
        }else if(type === "photo"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'PhotoFiche']);
            count = count.length
        }else if(type === "clotureFibsdd"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'ClotureFibsdd']);
            count = count.length
        }else if(type === "clotureBouteille"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'ClotureBouteille']);
            count = count.length
        }else if(type === "envoieFibsdd"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'clotureFibsdd']);
            count = count.length
        }else if(type === "envoieRestit"){
            count = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'restitutionBouteille']);
            count = count.length
        }

        return count;

    }

    // DETENTEURS
    static async syncDetenteur(action) {
        let id = action.id;
        let detenteur = await Detenteur.getDetenteur(id);
        let det = Detenteur.serialize(detenteur);
        let newId;
        let oldId = id;

        if (action.action === 'add') {
            let resAdd = await Detenteur.addDetenteurOnline(det);

            newId = resAdd.id;

            // AJOUTE LE NOUVEAU DET AU LOCAL
            let listDet = await Detenteur.getList();
            let newList = _.map(listDet, det => {
                if (det.id === oldId) {
                    det.id = newId
                }
                return det
            });

            await localforage.setItem('listDetenteurs', JSON.stringify(newList));
            await Offline.deleteAction(oldId, 'Detenteur');
            let listInstall = await Installation.getList();

            let lstToChange = _.map(listInstall, install => {
                if (install.detenteur === oldId) {
                    install.detenteur = newId
                }
                return install
            });

            await localforage.setItem('listInstallations', JSON.stringify(lstToChange));


            // UPDATE FIBSDDS
            let fibsddObj = new Fibsdd();
            let listFi = await fibsddObj.getList();

            let fisToChange = _.map(listFi, fi => {
                if (fi.detenteur !== null && typeof fi.detenteur === 'object' && !_.isEmpty(fi.detenteur) && fi.detenteur.id === oldId) {
                    fi.detenteur = newId
                } else if (fi.detenteur === oldId) {
                    fi.detenteur = newId
                }

                return fi
            });

            await localforage.setItem('listFibsdd', JSON.stringify(fisToChange));

            let contratObj = new ContratAssemblage();
            let listContrats = await contratObj.getList();

            let ContratsToChange = _.map(listContrats, contrat => {
                if (contrat.id_detenteur === oldId) {
                    contrat.id_detenteur = newId
                }
                return contrat
            });

            await localforage.setItem('listAssemblages', JSON.stringify(ContratsToChange))
        } else if(action.action === 'update'){
            await Detenteur.updateDeteneteurOnline(oldId);
            await Offline.deleteAction(oldId, 'Detenteur')
        }

        return true
    }

    static async syncDetenteurs(force = false) {
        let actionsDetenteur = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Detenteur']);

        for (const det of actionsDetenteur) {
            if (det.hasOwnProperty('id') && det.id) {
                await this.syncDetenteur(det)
            } else {
                await Offline.deleteAction(null, 'Detenteur')
            }
        }

        if(force === true) {
            localforage
                .getItem('api-token')
                .then(key => {
                    let api = new Initialisation(key);
                    api.initDetenteursAndInstall();
                })
        }

        return true;
    }

    // INSTALLATIONS
    static async syncInstallation(action) {
        let fibsddObj = new Fibsdd();
        let oldId = action.id;
        let newId;
        let installation = await Installation.getInstallation(action.id);
        let install = Installation.serialize(installation);

        if (action.action === 'add') {
            delete install.id;


            let resAdd = await Installation.addInstallationOnline(install);
            newId = resAdd.id;
            let installations = await Installation.getList();
            let newList = _.map(installations, install => {
                if (install.id === oldId) {
                    install.id = newId
                }
                return install
            });

            await localforage.setItem('listInstallations', JSON.stringify(newList));
            await Offline.deleteAction(oldId, 'Installation');

            let listFi = await fibsddObj.getList();

            // UPDATE FIBSDDS
            let lstToChange = _.map(listFi, fi => {
                if (fi.hasOwnProperty('installation') && fi.installation === oldId) {
                    fi.installation = newId
                }

                return fi
            });

            await localforage.setItem('listFibsdd', JSON.stringify(lstToChange));

            let lstInformation = await InformationInstallation.getList();

            let lstInfo = _.map(lstInformation, info => {
                if(info.hasOwnProperty('installation') && info.installation === oldId){
                    info.installation = newId;
                }

                return info;
            })

            await localforage.setItem('listInformationInstallation', JSON.stringify(lstInfo));

            return true;
        } else if (action.action === 'update') {
            await Installation.updateOnline(install);

            return true;
        }

    }
    static async syncInstallations(force = false) {

        let actions = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Installation']);

        for (const install of actions) {
            if (install.hasOwnProperty('id') && install.id) {
                await this.syncInstallation(install)
            } else {
                await Offline.deleteAction(null, 'Installation')
            }
        }

        if(force === true) {
            localforage
                .getItem('api-token')
                .then(key => {
                    let api = new Initialisation(key);
                    api.initDetenteursAndInstall();
                })
        }


        return true;

    }

    //Information installation
    static async syncInformationInstallations() {

        let actionsInformation = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'InformationInstallation']);

        for (const info of actionsInformation) {
            if (info.hasOwnProperty('id') && info.id) {
                await this.syncInformationInstallation(info)
            }
        }

    }

    static async syncInformationInstallation(action) {

        let info = await InformationInstallation.getInformationInstallation(action.id);

        if(action.action === "add") {
            delete info.id;
            await InformationInstallation.addInformationInstallationOnline(info);
        }

        return true;

    }

    // BOUTEILLES
    static async syncBouteille(action) {
        let bout = await Bouteille.getBouteille(action.id);
        let data = Bouteille.serialize(bout);
        let oldId = bout.id;
        let newId;
        let needRestit = false;

        if (data.restitution === true) {
            needRestit = true
        }

        data.restitution = false;

        if (action.action === 'add') {

            let newBout = await Bouteille.addBouteilleOnline(data);

            await Offline.deleteAction(oldId, 'Bouteille');

            newId = newBout.id;

            if (needRestit === true) {
                await Offline.saveAction({
                    action: 'update',
                    type: 'ClotureBouteille',
                    id: newId
                })
            }

            let listBout = await Bouteille.getList();
            let newBouts = _.map(listBout, b => {
                if (b.id === oldId) {
                    b.id = newId;
                }

                return b;
            });
            await localforage.setItem('listBouteilles', JSON.stringify(newBouts));


            let opBoutObj = new OperationBouteille;
            let listOp = await opBoutObj.getList();
            let lstToChange = _.map(listOp, op => {
                if (op.hasOwnProperty('id_bouteille') && op.id_bouteille === oldId) {
                    op.id_bouteille = newId;
                }

                return op;
            });

            await localforage.setItem('listOperations', JSON.stringify(lstToChange));
            let listScan = await Scan.getList();
            let newScans = _.map(listScan, scan => {
                if (scan.hasOwnProperty('bouteille') && scan.bouteille === oldId) {
                    scan.bouteille = newId;
                }

                return scan;
            });

            await localforage.setItem('listScans', JSON.stringify(newScans));

            let actionsOffline = await Offline.getList();
            let newActionsOff = _.map(actionsOffline, action => {

                if (action.type === 'restitutionBouteille') {
                    action.bouteilles = action.bouteilles.map(bouteille => {
                        if (bouteille === oldId) {
                            bouteille = newId;
                        }

                        return bouteille;
                    });
                }

                return action;
            });

            await localforage.setItem('offlineActions', JSON.stringify(newActionsOff));

            return true;
        } else if (action.action === 'update') {
            await Bouteille.updateOnline(oldId, data);
            await Offline.deleteAction(oldId, 'Bouteille');

            if (needRestit === true) {
                await Offline.saveAction({
                    action: 'update',
                    type: 'ClotureBouteille',
                    id: oldId
                })
            }

            return true;
        }
    }

    static async syncBouteilles() {
        let actions = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Bouteille']);

        for (const bouteille of actions) {
            if (bouteille.hasOwnProperty('id') && bouteille.id) {
                await this.syncBouteille(bouteille)
            } else {
                await Offline.deleteAction(null, 'Bouteille')
            }
        }

        return true;
    }

    // OUTILS
    static async syncOutil(action) {
        let listOutils = await Outil.getList();
        let outil = await Outil.getOutil(action.id);
        let oldId = outil.id;
        let newId;

        if (action.action === 'add') {
            let added = await Outil.addOutilOnline(outil);
            newId = added.id;
            let newList = _.map(listOutils, outil => {
                if (outil.id === oldId) {
                    outil.id = newId;
                }

                return outil;
            });

            await localforage.setItem('listOutils', JSON.stringify(newList));

            await Offline.deleteAction(oldId, 'Outil');

            let fibsddObj = new Fibsdd;
            let listFi = await fibsddObj.getList();

            // UPDATE FIBSDDS
            let lstToChange = _.map(listFi, fi => {
                if (fi.hasOwnProperty('detecteur') && fi.detecteur === oldId) {
                    fi.detecteur = newId;
                }

                return fi;
            });

            await localforage.setItem('listFibsdd', JSON.stringify(lstToChange));

            return true;
        } else if (action.action === 'update') {
            await Outil.updateOnline(outil);
            return true;
        }
    }

    static async syncOutils() {
        let actionsOutil = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Outil']);

        for (const outil of actionsOutil) {
            if (outil.hasOwnProperty('id') && outil.id) {
                await this.syncOutil(outil);
            } else {
                await Offline.deleteAction(null, 'Outil');
            }
        }

        return true;
    }

    // CONTRATS D'ASSEMBLAGE
    static async syncAssemblage(id) {
        return new Promise((resolve, reject) => {
            let contratObj = new ContratAssemblage();

            contratObj
                .getContrat(id)
                .then(data => {
                    contratObj
                        .saveContratOnline(data)
                        .then(res => {
                            if (res.statusText === 'OK') {

                                Offline.deleteAction(data.id, 'ContratAssemblage');
                                contratObj
                                    .deleteContrat(data.id)
                                    .then(resolve(true))

                            }
                        }).catch(err => reject(err));
                }).catch(err => reject(err));
        })
    }

    static async syncContrats() {
        let actions = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'ContratAssemblage']);

        for (const contrat of actions) {
            if (contrat.hasOwnProperty('id') && contrat.id) {
                await this.syncAssemblage(contrat.id)
            } else {
                await Offline.deleteAction(null, 'ContratAssemblage')
            }
        }

        return true;
    }

    // FIBSDDS
    static async syncFibsdd(action) {
        return new Promise((resolve, reject) => {
            let fiObj = new Fibsdd();
            let opObj = new OperationBouteille;

            if (action.id === null || action.id === undefined) {
                return resolve(true);
            }

            fiObj.getFibsdd(action.id).then(data => {
                if (data === undefined) {
                    Offline
                        .deleteAction(action.id, 'Fibsdd')
                        .then(Offline.deleteAction(action.id, 'ClotureFibsdd'))
                        .then(() => resolve(true));
                } else {
                    let fi = Fibsdd.serialize(data);
                    let oldId = data.id;
                    let newId;
                    let needCloture = false;

                    if (fi.cloture === true) {
                        fi.cloture = false;
                        needCloture = true
                    }

                    if (action.action === 'add') {
                        fiObj
                            .addOnlineFibsdd(fi)
                            .then(res => {
                                return new Promise((resolve, reject) => {
                                    newId = res.id;

                                    fiObj.getList().then(list => {

                                        let newFis = _.map(list, fi => {
                                            if (fi.id === oldId) {
                                                fi.id = newId
                                            }
                                            return fi
                                        });

                                        localforage
                                            .setItem('listFibsdd', JSON.stringify(newFis))
                                            .then(() => {
                                                resolve(true)
                                            })
                                            .catch(err => reject(err))
                                    })
                                })
                            })
                            .then(() => {
                                if (needCloture === true) {
                                    return Offline.saveAction({
                                        action: 'update',
                                        type: 'ClotureFibsdd',
                                        id: newId
                                    })
                                } else {
                                    return new Promise((resolve) => {
                                        resolve(true)
                                    })
                                }
                            })
                            .then(() => {
                                return Offline.deleteAction(oldId, 'Fibsdd')
                            })
                            .then(() => {

                                return new Promise((resolve, reject) => {

                                    Offline
                                        .getList()
                                        .then(list => {

                                            let newList = list.map(off => {

                                                if (off.type === "clotureFibsdd" && off.idFi === oldId) {
                                                    off.idFi = newId
                                                }
                                                return off;

                                            });

                                            localforage
                                                .setItem('offlineActions', JSON.stringify(newList))
                                                .then(() => resolve(true))
                                                .catch(err => reject(err))

                                        })
                                        .catch(err => reject(err))

                                })

                            })
                            .then(() => {

                                return new Promise((resolve, reject) => {

                                    opObj.getList().then(list => {

                                        let newOps = _.map(list, op => {
                                            if (op.id_fibsdd === oldId) {
                                                op.id_fibsdd = newId;
                                            }

                                            return op;
                                        });

                                        localforage
                                            .setItem('listOperations', JSON.stringify(newOps))
                                            .then(() => {
                                                resolve(true);
                                            })
                                            .catch(err => reject(err))
                                    })
                                })
                            })
                            .then(() => {

                                return new Promise((resolve, reject) => {

                                    Fuite
                                        .getList()
                                        .then(list => {

                                            let newFuites = _.map(list, f => {
                                                if (f.dossier === oldId) {
                                                    f.dossier = newId
                                                }
                                                return f
                                            });

                                            localforage
                                                .setItem('listFuites', JSON.stringify(newFuites))
                                                .then(res => {
                                                    resolve(true)
                                                })
                                                .catch(err => reject(err))

                                        })
                                        .catch(err => reject(err))

                                })


                            })
                            .then(res => {

                                return new Promise((resolve, reject) => {

                                    Piece
                                        .getList()
                                        .then(list => {

                                            let newPieces = list.map(p => {
                                                if(p.fiche === oldId){
                                                    p.fiche = newId
                                                }
                                                return p
                                            });

                                            localforage
                                                .setItem('listPieces', JSON.stringify(newPieces))
                                                .then(res => {
                                                    resolve(true)
                                                })
                                                .catch(err => reject(err))

                                        })
                                        .catch(err => reject(err))

                                })

                            })
                            .then(res => {

                                return new Promise((resolve, reject) => {

                                    PhotoFiche
                                        .getList()
                                        .then(list => {

                                            let newPhotos = list.map(p => {
                                                if(p.idFi === oldId){
                                                    p.idFi = newId
                                                }
                                                return p

                                            });

                                            localforage
                                                .setItem('listPhotos', JSON.stringify(newPhotos))
                                                .then(res => {
                                                    resolve(true)
                                                })
                                                .catch(err => reject(err))

                                        })
                                        .catch(err => reject(err))

                                })

                            })
                            .then(res => resolve(true))
                            .catch(err => reject(err))

                    } else if (action.action === 'update') {

                        fiObj
                            .updateOnline(fi, data.id)
                            .then(res => {
                                return Offline.deleteAction(res.id, 'Fibsdd')
                            })
                            .then(() => {

                                if (needCloture === true) {
                                    return Offline.saveAction({
                                        action: 'update',
                                        type: 'ClotureFibsdd',
                                        id: data.id
                                    })
                                } else {
                                    return new Promise((resolve) => {
                                        resolve(true)
                                    })
                                }

                            })
                            .then(() => resolve(true))
                            .catch(err => reject(err))

                    }

                }

            }).catch(() => {
                Offline
                    .deleteAction(action.id, 'Fibsdd')
                    .then(Offline.deleteAction(action.id, 'ClotureFibsdd'))
                    .then(() => resolve(true));
            })

        })

    }
    static async syncFibsdds() {

        let actions = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Fibsdd']);

        for (const fi of actions) {
            if(fi.hasOwnProperty('id') && fi.id){
                await this.syncFibsdd(fi)
            } else {
                await Offline.deleteAction(null, 'Fibsdd')
            }
        }

        return true;

    }

    // OPERATIONS BOUTEILLE
    static async syncOperationBouteille(action) {

        return new Promise((resolve, reject) => {

            let opObj = new OperationBouteille;
            let id = action.id;

            if (action.action === 'delete') {

                opObj
                    .removeOnlineOperation(action.id)
                    .then(() => resolve(true))
                    .catch(err => reject(err))

            } else if (action.action === 'add') {

                opObj
                    .getOperation(id)
                    .then(op => {

                        opObj
                            .addOnlineOperation(op)
                            .then(res => resolve(res))
                            .catch(err => reject(err))

                    })
                    .catch(() => {
                        reject('Erreur lors de la récupération de l\'opération')
                        //opObj.removeOperation(id)
                    })
            }

        })

    }
    static async syncOperationsBouteille() {

        let actions = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'OperationBouteille']);

        for (const op of actions) {
            if (op.hasOwnProperty('id') && op.id) {
                await this.syncOperationBouteille(op)
            } else {
                await Offline.deleteAction(null, 'OperationBouteille')
            }
        }

        return true;

    }

    // SCANS BOUTEILLE
    static async syncScanBouteille(id) {

        return new Promise((resolve, reject) => {

            Scan
                .addOnlineScanBouteille(id)
                .then(() => resolve(true))
                .catch(err => reject(err))

        })
    }
    static async syncScansBouteille() {
        let actions = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'ScanBouteille']);

        for (const scan of actions) {
            if (scan.hasOwnProperty('id') && scan.id) {
                await this.syncScanBouteille(scan.id)
            } else {
                await Offline.deleteAction(null, 'ScanBouteille')
            }
        }

        return true;

    }

    static async syncScanInstallation(id) {
        return new Promise((resolve, reject) => {

            Scan
                .addOnlineScanInstallation(id)
                .then(() => resolve(true))
                .catch(err => reject(err))
        })
    }

    static async syncScansInstallations() {

        let actions = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'ScanInstallation']);

        for (const scan of actions) {
            if(scan.hasOwnProperty('id') && scan.id){
                await this.syncScanInstallation(scan.id)
            } else {
                await Offline.deleteAction(null, 'ScanInstallation')
            }
        }
        return true;
    }

    // FUITES
    static async syncFuite(f) {

        return new Promise((resolve, reject) => {

            if (f.action === 'delete') {

                Fuite
                    .removeFuiteOnline(f)
                    .then(() => resolve(true))
                    .catch(err => reject(err))

            } else {

                Fuite
                    .getFuite(f.id)
                    .then(fuite => {

                        if (f.action === "add") {

                            Fuite
                                .addFuiteOnline(fuite)
                                .then(() => resolve(true))
                                .catch(err => reject(err))

                        } else if (f.action === "update") {

                            Fuite
                                .updateFuiteOnline(fuite)
                                .then(() => resolve(true))
                                .catch(err => reject(err))

                        }

                    })
                    .catch(err => reject(err))
            }

        })

    }
    static async syncFuites() {

        let actions = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Fuite']);

        for (const fuite of actions) {
            if (fuite.hasOwnProperty('id') && fuite.id) {
                await this.syncFuite(fuite)
            } else {
                await Offline.deleteAction(null, 'Fuite')
            }
        }

        return true;

    }

    // PIECES
    static async syncPiece(p) {

        return new Promise((resolve, reject) => {

            if (p.action === 'delete') {

                Piece
                    .removeOnline(p.id)
                    .then(() => resolve(true))
                    .catch(err => reject(err))

            } else {

                Piece
                    .addOnline(p.id)
                    .then(() => resolve(true))
                    .catch(err => reject(err))


            }

        })

    }
    static async syncPieces() {

        let actions = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'Piece']);

        for (const piece of actions) {
            if (piece.hasOwnProperty('id') && piece.id) {
                await this.syncPiece(piece)
            } else {
                await Offline.deleteAction(null, 'Piece')
            }
        }

        return true;

    }

    // PHOTOS FICHE
    static async syncPhoto(p) {

        return new Promise((resolve, reject) => {

            if (p.action === 'delete') {

                PhotoFiche
                    .removeOnline(p.id)
                    .then(() => resolve(true))
                    .catch(err => reject(err))

            } else {

                PhotoFiche
                    .addOnline(p.id)
                    .then(() => resolve(true))
                    .catch(err => reject(err))


            }

        })

    }
    static async syncPhotos() {

        let actions = _.filter(JSON.parse(await localforage.getItem('offlineActions')), ['type', 'PhotoFiche']);

        for (const photo of actions) {
            if (photo.hasOwnProperty('id') && photo.id) {
                await this.syncPhoto(photo)
            } else {
                await Offline.deleteAction(null, 'PhotoFiche')
            }
        }

        return true;

    }

    // USER
    static async syncUser() {

        return new Promise((resolve, reject) => {

            Offline
                .getList()
                .then(list => {

                    let usr = _.filter(list, ['type', 'User']);

                    if (usr.length !== 0) {

                        User
                            .updateOnline(usr)
                            .then(res => {

                                Offline
                                    .getList()
                                    .then(list => {

                                        let newList = _.filter(list, action => {
                                            if (action.type !== 'User') {
                                                return action
                                            }
                                        });

                                        localforage
                                            .setItem('offlineActions', JSON.stringify(newList))
                                            .then(() => resolve(res))
                                            .catch(err => reject(err))

                                    })
                                    .catch(err => reject(err))
                            })
                            .catch(err => {
                                reject(err)
                            })

                    } else {

                        resolve(true)

                    }

                })

        })

    }

    // --------------------------

    // LANCE UNE RESTITUTION
    static async launchRestitBouteille(restit) {

        return new Promise((resolve, reject) => {



            let obj = {};
            obj.bouteilles = restit.bouteilles;
            obj.distributeur = restit.sendMail;
            obj.dist = restit.distributeur;

            Api
                .init()
                .then(api => {
                    api
                        .post('/mail/bouteille', obj)
                        .then(res => {

                            if (!res.data.hasOwnProperty('errors')) {
                                resolve(true)
                            } else {
                                reject(res.data.errors)
                            }
                        })
                        .catch(err => {
                            if(err.response.status === 403 || err.response.status === 404){
                                resolve(true)
                            } else {
                                reject(err)
                            }
                        })
                })
                .catch(err => reject(err))
        })

    }

    // FONCTION LANCE RESTITUTIONS
    static async launchRestitsBouteille() {

        let offlineActions = JSON.parse(await localforage.getItem('offlineActions'));
        let actionsToSync = _.filter(offlineActions, ['type', 'restitutionBouteille']);

        for (const restit of actionsToSync) {
            await Synchro.launchRestitBouteille(restit)
        }

        let newListOffline = _.reject(offlineActions, ['type', 'restitutionBouteille']);
        await localforage.setItem('offlineActions', JSON.stringify(newListOffline));

        return true;

    }

    // LANCE LE MAIL POUR UNE FI CLOTURÉE
    static async launchMailFibsdd(restit) {
        return new Promise((resolve, reject) => {
            let obj = {};
            obj.detenteur = restit.sendMail;

            Api
                .init()
                .then(api => {
                    api
                        .post('/mail/cloturefi/' + restit.idFi, obj)
                        .then(res => {

                            if (!res.data.hasOwnProperty('errors')) {
                                resolve(true)
                            } else {
                                reject(res.data.errors)
                            }
                        })
                        .catch(err => {
                            if(err.response.status === 403 || err.response.status === 404){
                                resolve(true)
                            } else {
                                reject(err)
                            }
                        })
                })
                .catch(err => reject(err))
        });
    }

    // LANCE LES MAILS FIBSDD
    static async launchMailsFibsdd() {

        let offlineActions = JSON.parse(await localforage.getItem('offlineActions'));
        let actionsToSync = _.filter(offlineActions, ['type', 'clotureFibsdd']);

        for (const cloture of actionsToSync) {
            await Synchro.launchMailFibsdd(cloture)
        }

        let newListOffline = _.reject(offlineActions, ['type', 'clotureFibsdd']);
        await localforage.setItem('offlineActions', JSON.stringify(newListOffline));

        return true;

    }

    // LANCE UNE CLOTURE FIBSDD
    static async clotureFinaleFibsdd(cloture) {

        return new Promise((resolve, reject) => {

            const fibsddId = cloture.id || cloture.idFi;

            if (!fibsddId) {
                return resolve(true);
            }


            Api
                .init()
                .then(api => {

                    let fiObj = new Fibsdd;

                    fiObj
                        .getFibsdd(fibsddId)
                        .then(fi => {


                        // Fiche supprimée en local : on retire l'action et on continue
                        if (!fi) {
                            return Offline.deleteAction(fibsddId, 'ClotureFibsdd')

                                .then(() => Offline.deleteAction(fibsddId, 'clotureFibsdd'))
                                .then(() => resolve(true));
                        }

                        let fibsdd = Fibsdd.serialize(fi);

                        let payload = {
                            cloture: true,
                            numero: fibsdd.numero,
                            detenteur: fibsdd.detenteur,
                            installation: fibsdd.installation,
                            chargeInitiale: fibsdd.chargeInitiale,
                            callback: fibsdd.callback,

                        };

                        payload.detecteur = (fibsdd.detecteur !== null) ? fibsdd.detecteur : null;

                        if(fibsdd.interventionControleNp === false && fibsdd.interventionControleP === false){
                            payload.detecteur = null
                        }

                        api
                            .patch('/fibsdd/' + fibsddId, payload)
                            .then(res => {
                                return Offline.deleteAction(fibsddId, 'ClotureFibsdd')
                            })
                            .then(res => resolve(true))
                            .catch(err => {

                                err.payload = payload;

                                if(err.response && (err.response.status === 403 || err.response.status === 404)){

                                    return Offline
                                        .deleteAction(fibsddId, 'ClotureFibsdd')
                                        .then(() => Offline.deleteAction(fibsddId, 'clotureFibsdd'))
                                        .then(() => resolve(true))
                                        .catch(err => reject(err))

                                } else {

                                    return reject(err)
                                }

                            })

                    })
                        .catch(() => {
                            // Fiche introuvable (ex. listFibsdd vide) : on retire l'action
                            Offline
                                .deleteAction(fibsddId, 'ClotureFibsdd')
                                .then(() => Offline.deleteAction(fibsddId, 'clotureFibsdd'))
                                .then(() => resolve(true))
                        })
                })
                .catch(err => reject(err))


        })

    }

    // LANCER LES CLOTURES FIBSDD
    static async cloturesFinalesFibsdd() {

        let offlineActions = JSON.parse(await localforage.getItem('offlineActions'));
        let actionsToSync = _.filter(offlineActions, off => off.type === 'ClotureFibsdd' || off.type === 'clotureFibsdd');
        
        for (const cloture of actionsToSync) {
            await Synchro.clotureFinaleFibsdd(cloture)
        }

        return true;

    }

    // UPDATE LA BOUTEILLE AVEC RESTITUTION = 1 POUR GENERATION DE PDF
    static async clotureFinaleBouteille(cloture) {
        let bouteille = await Bouteille.getBouteille(cloture.id);
        let bout = Bouteille.serialize(bouteille);
        bout.restitution = true;

        let api = await Api.init();

        try {
            await api.put('/bouteille/' + cloture.id, bout);
        } finally {
            await Offline.deleteAction(cloture.id, 'ClotureBouteille');
        }

        return true

    }

    static async cloturesFinalesBouteille() {
        let offlineActions = JSON.parse(await
            localforage.getItem('offlineActions')
        );
        let actionsToSync = _.filter(offlineActions, ['type', 'ClotureBouteille']);

        for (const cloture of actionsToSync) {
            await
                Synchro.clotureFinaleBouteille(cloture)
        }

        return true;
    }

    static async syncOfflineData() {

        try {

            await Synchro.syncUser();
            await Synchro.syncDetenteurs();
            await Synchro.syncInstallations();
            await Synchro.syncBouteilles();
            await Synchro.syncOutils();
            await Synchro.syncContrats();
            await Synchro.syncFibsdds();
            await Synchro.syncOperationsBouteille();
            await Synchro.syncScansBouteille();
            await Synchro.syncFuites();
            await Synchro.syncPieces();
            await Synchro.cloturesFinalesFibsdd();
            await Synchro.cloturesFinalesBouteille();
            await Synchro.launchMailsFibsdd();
            await Synchro.launchRestitsBouteille();
            return true;

        } catch (e) {
            swal('Erreur', e, 'error');
            return false

        }

    }

}

export default Synchro



// WEBPACK FOOTER //
// ./src/js/core/Synchro.js